module.exports = __webpack_public_path__ + "static/media/social.9e22d4de.png";